import { Component, ElementRef, Renderer2 } from '@angular/core';
import { environment } from '../environments/environment';
import { AnalyticsService } from './services/analytics-service';

@Component({
  selector: 'app-root',
  template: `
    <div class="app-container">
      <router-outlet></router-outlet>
      <app-floating-button></app-floating-button>
      <div class="w3-container">
        <div id="id01" class="w3-modal">
          <app-popup-box></app-popup-box>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .app-container {
      height: 100vh;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
    }
  `]
})
export class AppComponent {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private analyticService: AnalyticsService
  ) { }

  ngOnInit(): void {
    if (environment.production) {
      this.analyticService.init();
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'ng-version');
    }
  }
}
